import { TranslationKey } from '~/lib';

export type PromotionGroupKey =
    | 'tilbud'
    | 'superpris'
    | 'medlemspris'
    | 'maengderabatter'
    | 'julepris';

type PromotionGroup = {
    key: PromotionGroupKey;
    labelKey: TranslationKey;
    /** Raw `cust_activepromo.promotiontype` facet values this group covers. */
    values: string[];
};

// Groups raw cust_activepromo.promotiontype values into the 5 Figma categories; hardcoded since Algolia has no category field.
// Values are matched case-insensitively, as their spelling differs per environment (e.g. Julepris/JulePris, Mix/Mix & Match).
export const PROMOTION_GROUPS: PromotionGroup[] = [
    { key: 'tilbud', labelKey: 'plp.salesOffers.tilbud', values: ['Tilbud'] },
    { key: 'superpris', labelKey: 'plp.salesOffers.superpris', values: ['SuperPris'] },
    { key: 'medlemspris', labelKey: 'plp.salesOffers.medlemspris', values: ['Medlemspris'] },
    {
        key: 'maengderabatter',
        labelKey: 'plp.salesOffers.maengderabatter',
        values: [
            'Køb 2 for',
            'Køb 3 for',
            'Køb 4 for',
            'Køb 6 for',
            'Køb som sæt',
            'Mix & Match',
            'Mix',
        ],
    },
    { key: 'julepris', labelKey: 'plp.salesOffers.julepris', values: ['Julepris'] },
];
